import { SectorDepotTreeSelect } from '@/components/_SiteWide/SectorDepotTreeSelect'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  PlusOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { IconPencilBolt } from '@tabler/icons-react'
import { DatePicker } from 'antd'
import { Segmented, Select } from 'antd'
import { useSchedulePageFilters } from '../../Context/Filters/SchedulePageFilterContext'
import { AddTemplateModal } from '../Modals/AddTemplateModal'
import { BulkAddShiftsModal } from '../Modals/BulkEditShiftsModal'

export function TopToolbar() {
  const { datePickerType, datePickerValue, viewMode, setFilters, depot } = useSchedulePageFilters()

  return (
    <Horizontal width='100%' className='px-3' gap={24} style={{ flexWrap: 'nowrap' }} verticalCenter>
      <SectorDepotTreeSelect
        onChange={(v) => setFilters((filters) => ({ ...filters, depot: v }))}
        value={depot}
        size='middle'
        placeholder='Filter By Depot'
      />
      <Horizontal gap={4}>
        <GraviButton
          icon={<ArrowLeftOutlined />}
          onClick={() =>
            setFilters((filters) => ({
              ...filters,
              datePickerValue: datePickerValue.clone().subtract(1, datePickerType),
            }))
          }
        />
        <DatePicker
          value={datePickerValue}
          onChange={(v) => setFilters((filters) => ({ ...filters, datePickerValue: v }))}
          picker={datePickerType}
          allowClear={false}
          showWeek={false}
          style={{ display: 'flex' }}
          format={(val) =>
            datePickerType === 'week'
              ? `Week of ${val.clone().startOf('week').format('MMM DD')}`
              : val.format('MMM YYYY')
          }
        />
        <GraviButton
          icon={<ArrowRightOutlined />}
          onClick={() =>
            setFilters((filters) => ({
              ...filters,
              datePickerValue: datePickerValue.clone().add(1, datePickerType),
            }))
          }
        />
      </Horizontal>

      <Segmented
        value={datePickerType}
        onChange={(v) => setFilters((filters) => ({ ...filters, datePickerType: v }))}
        style={{ display: 'flex' }}
        options={[
          { value: 'week' as const, icon: <UnorderedListOutlined /> },
          { value: 'month' as const, icon: <CalendarOutlined /> },
        ]}
      />

      <Select
        value={viewMode}
        options={[
          { value: 'driver', label: 'Driver View' },
          { value: 'tractor', label: 'Tractor View' },
        ]}
        onChange={(v) => setFilters((filters) => ({ ...filters, viewMode: v }))}
        style={{ width: 140 }}
      />

      {viewMode === 'driver' && (
        <BulkAddShiftsModal theme1>
          <Horizontal alignItems='center'>
            <IconPencilBolt size={18} />
            <span className='ml-2'>Bulk Edit Shift Times</span>
          </Horizontal>
        </BulkAddShiftsModal>
      )}
      {viewMode === 'driver' && (
        <AddTemplateModal theme1 icon={<PlusOutlined />}>
          Apply Template
        </AddTemplateModal>
      )}
    </Horizontal>
  )
}
